export default __webpack_public_path__ + "static/media/andrecardoso.41e2a6e9.png";